import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environments';


@Injectable({ providedIn: 'root' })
export class FormationsService {
  private http = inject(HttpClient);
  private apiUrl = environment.apiUrl + 'api/formations';

  private authHeaders() {
    return new HttpHeaders({
      Authorization: `Bearer ${localStorage.getItem('token') || ''}`
    });
  }

  // Public
  getFormations(): Observable<any[]> {
    return this.http.get<any[]>(`${this.apiUrl}/all`);
  }

  getFormationById(formationId: number): Observable<any[]> {
    return this.http.get<any[]>(`${this.apiUrl}/one/${formationId}`);
  }

  downloadFormation(formationId: number, userId: number): Observable<Blob> {
    return this.http.get(
      `${this.apiUrl}/${formationId}/download/${userId}`,
      {
        responseType: 'blob'
      }
    );
  }

  getFormationsBasedOnUser(user_id: any): Observable<any[]> {
    return this.http.get<any[]>(`${this.apiUrl}/filtered/${user_id}`);
  }

  // Admin list
  getAdminFormations(): Observable<any[]> {
    return this.http.get<any[]>(`${this.apiUrl}/admin`, { headers: this.authHeaders() });
  }

  // Admin create
  createFormation(payload: any): Observable<any> {
    console.log("this is the data to send", payload);
    return this.http.post(`${this.apiUrl}/admin/create`, payload);
  }

  editFormation(payload: any): Observable<any> {
    console.log("this is the data to send from rdit mode", payload);
    return this.http.put(`${this.apiUrl}/admin/edit`, payload);
  }

  // Admin update
  updateFormation(id: number, payload: Partial<any>): Observable<any> {
    return this.http.put(`${this.apiUrl}/admin/${id}`, payload, { headers: this.authHeaders() });
  }

  // Upload cover
  uploadCover(id: number, file: File): Observable<any> {
    const form = new FormData();
    form.append('file', file);
    return this.http.post(`${this.apiUrl}/admin/${id}/upload-cover`, form, { headers: this.authHeaders() });
  }

  // Upload pdf
  uploadPdf(id: number, file: File): Observable<any> {
    const form = new FormData();
    form.append('file', file);
    return this.http.post(`${this.apiUrl}/admin/${id}/upload-pdf`, form, { headers: this.authHeaders() });
  }
}
